import AlertModal from "./AlertModal";
import ConfirmModal from "./ConfirmModal";
import DeviceInfoModal from "./DeviceInfoModal/DeviceInfoModal";
import DeviceContentInfo from "./DeviceContentInfo";
import FormModal from "./FormModal";

export const modalTypes = {
    AlertModal,
    ConfirmModal,
    DeviceInfoModal,
    DeviceContentInfo,
    FormModal
};
